import { IonFooter, IonToolbar, IonButtons, IonButton, IonIcon } from '@ionic/react';
import { home, gameController, wallet, person, cashOutline } from 'ionicons/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './BottomNav.css';

const BottomNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // Don't show bottom nav on login/home pages
  const hideNavPaths = ['/login', '/home'];
  const shouldHide = hideNavPaths.some(path => location.pathname.includes(path)) || !currentUser;

  if (shouldHide) {
    return null;
  }

  const navItems = [
    { path: '/dashboard', icon: home },
    { path: '/games', icon: gameController },
    { path: '/watch-ad', icon: cashOutline },
    { path: '/wallet', icon: wallet },
    { path: '/profile', icon: person },
  ];

  const isActive = (path: string) => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <IonFooter>
      <IonToolbar color="primary">
        <IonButtons className="bottom-nav-buttons">
          {navItems.map((item) => (
            <IonButton
              key={item.path}
              onClick={() => navigate(item.path)}
              className={isActive(item.path) ? 'nav-active' : ''}
              fill="clear"
            >
              <IonIcon icon={item.icon} />
            </IonButton>
          ))}
        </IonButtons>
      </IonToolbar>
    </IonFooter>
  );
};

export default BottomNav;

